import '../SASS/home.scss'
import { Link } from 'react-router-dom'
import Navbar from './Navbar'
import SocialLink from './SocialLink'
import hi from '../Assets/svg/hi.svg'
import my from '../Assets/svg/my.svg'
import there from '../Assets/svg/there.svg'
import name from '../Assets/svg/name.svg'
const Home = () => {
  return (
    <>
      <main className="container">
        <SocialLink />
        <article className="home-page">
          <div className="hero-left">
            <div className="text-zone">
              <h1>Mohammad Ishan </h1>
              <h2>Front-end Web Developer</h2>
              <p>
                I design and code beautifull simple things, and I love what I
                do.
              </p>
              <Link to={'/contact'} className="flat-button">
                CONTACT ME
              </Link>
            </div>
          </div>
        </article>
        <Navbar />
        {/* =======svg container========= */}

        <div className="bg-svg">
          <div className="hi-svg">
            <img src={hi} alt="hi" aria-hidden="true" />
          </div>

          <div className="my-svg">
            <img src={my} alt="" aria-hidden="true" />
          </div>

          <div className="there-svg">
            <img src={there} alt="" aria-hidden="true" />
          </div>

          <div className="name-svg">
            <img src={name} alt="" />
          </div>
        </div>
      </main>
    </>
  )
}

export default Home
